import { render, staticRenderFns } from "./InformationPanelStudent.vue?vue&type=template&id=41267266&scoped=true&lang=pug&"
import script from "./InformationPanelStudent.vue?vue&type=script&lang=ts&"
export * from "./InformationPanelStudent.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPanelStudent.vue?vue&type=style&index=0&id=41267266&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41267266",
  null
  
)

export default component.exports